import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import PropTypes from "prop-types";
import assetPath from "~/utils/assetPath";
import MenuContainer from "./containers/MenuContainer";
import AboutComponent from "./components/AboutComponent";
import CollectionsComponent from "./components/CollectionsComponent";
import TopicsComponent from "./components/TopicsComponent";
import CollectionComponent from "./components/CollectionComponent";

import { isEmbedApp, isGamedistributionApp } from "~/utils/misc";

import styles from "./Collections.scss";

class Collections extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    id: PropTypes.string
  }

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    // Initialize perfect scrollbar
    if (is.falsy(bowser.mobile) && is.falsy(bowser.tablet)) {
      // Initialize perfect scrollbar
      $("#app").perfectScrollbar({ suppressScrollX: true });

      // Only show scroll on scroll
      let scrollTimer;
      $("#app").on("ps-scroll-y", () => {
        // Add class to scrollbar
        $(".ps__scrollbar-y-rail").addClass("scrolling");

        // Reset window resize timer
        if (is.existy(scrollTimer)) {
          clearTimeout(scrollTimer);
        }

        // Call scroll timer
        scrollTimer = _.delay(() => {
          // Remove class from scrollbar
          $(".ps__scrollbar-y-rail").removeClass("scrolling");
        }, 1280);
      });
    }

    // Load background overlay and then fade it in
    const backgroundOverlayImage = new Image();
    backgroundOverlayImage.onload = (event) => {
      $("#background_image").css("opacity", 1)
    }
    backgroundOverlayImage.src = assetPath("background_overlay", "png")
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="collections_route">
        <div id="collection_container">
          <MenuContainer
            shouldShowBackButton={is.existy(this.props.id)}
            isPuzzlePage={false}
            onRef={ref => {
              this.menuContainer = ref;
            }}
          />
          <Choose>
            <When condition={this.props.type === "topics" && is.existy(this.props.id)}>
              <TopicsComponent id={this.props.id} />
            </When>
            <Otherwise>
              <TopicsComponent />
            </Otherwise>
          </Choose>
        </div>
        <If condition={!this.props.type && !isEmbedApp() && !isGamedistributionApp()}>
          <AboutComponent />
        </If>
      </div>
    );
  }
}

export default withStyles(styles)(Collections);



// WEBPACK FOOTER //
// ./src/routes/collections/Collections.js